import { Component } from '@angular/core';

@Component({
  selector: 'app-center-content',
  templateUrl: './center-content.component.html',
  styleUrl: './center-content.component.scss',
})
export class CenterContentComponent {}
